import React, { FC, ReactNode } from "react";
import { ENVWarning } from "@components/ui/ENVWarning";
import { useRouter } from "next/router";
import { Wrapper } from "../styles";
import { PreferenceModal } from "@components/common/Navbar/components/Preferences";
import Navbar from "./Navbar";
import Footer from "@components/common/Footer";
import { usePreferences } from "@helpers/hooks/usePreferences";

const DefaultLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const router = useRouter();
  const { modalPreferencesVisible } = usePreferences();

  // Hide footer for these specific end points
  const showFooter = () => {
    if (router.asPath.startsWith("/auth/supplier/tours/")) {
      return false;
    }
    return true;
  };

  return (
    <Wrapper>
      {/* <GlobalNotice /> */}
      <main style={{ minHeight: "500px" }}>
        <div className="print:hidden">
          <ENVWarning />
          <Navbar />
        </div>
        {modalPreferencesVisible && <PreferenceModal />}
        {children}
      </main>
      {showFooter() && <Footer />}
    </Wrapper>
  );
};

export default DefaultLayout;
